// extracted by mini-css-extract-plugin
module.exports = {"auth":"Auth_auth__1O7pk","control":"Auth_control__3AaY0"};